import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Icon from './Icon';
import { translate } from './Translate';

const Input = styled<any, any>('input') `
    flex: 1;
    border: none;
    outline: none;
    font: inherit;
    background-color: transparent;
    overflow: hidden;
    &::-ms-clear {
        display: none;
    }
`;

const SearchInput = styled<any, any>('div') `
    ${propStyles};
`;

SearchInput.defaultProps = {
    display: "flex",
    flex: "1 0 auto",
    fontSize: "inherit",
    fontFamily: "body",
    fontWeight: "normal",
    paddingX: "sm",
    paddingY: "sm",
    marginY: "sm",
    bgColor: "white",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "solid",
    borderRadius: "sm"
};

const ClearSearch = styled<any, any>('button') `
    ${propStyles};
    cursor: pointer;
    outline: none;
`;

ClearSearch.defaultProps = {
    color: "inherit",
    bgColor: "transparent",
    borderStyle: "none"
};

const ClearIcon = styled<any, any>(Icon)``;

ClearIcon.defaultProps = {
    cursor: "pointer",
    height: "1em",
    width: "1em"
};

export const FilterSearch: React.SFC<any> = ({ theme, translations, placeholder, value, onChange, onClear, showClear, ...props }) => (
    <SearchInput
        {...theme.FilterSearch}
        {...props}
    >
        <Input
            type="text"
            autoCapitalize="off"
            autoComplete="off"
            spellCheck="false"
            autoCorrect="off"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
        />
        {
            showClear &&
            <ClearSearch
                title={translate(translations, "Clear Search")}
                onClick={onClear}
            >
                <ClearIcon fileName="CloseIcon" />
            </ClearSearch>
        }
    </SearchInput>
);

export default observer(withTheme(FilterSearch)) as any;


// WEBPACK FOOTER //
// ./src/Components/FilterSearch.tsx